import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { HiX } from "react-icons/hi";

function AssignStaff({ task, onClose, getAllTasks, id }) {
  const [loading, setLoading] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [staffs, setStaffs] = useState([]);
  const [assignedStaff, setAssignedStaff] = useState(task?.staffAssigned?._id);

  //Function to get all the staffs
  const getAllStaffs = () => {
    setLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/user/get-all-staffs`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of getAllStaff: ", response.data);
        setStaffs(response.data.staffs);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    getAllStaffs();
  }, []);

  const handleSubmit = () => {
    setSubmitLoader(true);
    const data = {
      staffID: assignedStaff,
      adminID: id,
    };

    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/task/assign-staff-to-task/${task._id}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of handleSubmit: ", response.data);
        setSubmitLoader(false);
        onClose();
        getAllTasks();
        toast.success(response.data.message);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Error in assigning staff");
        setSubmitLoader(false);
      });
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm backdrop-brightness-75 "
      onClick={onClose}
    >
      <div
        className="relative max-h-fit w-[95%] max-w-lg overflow-y-scroll rounded-lg bg-white p-8 shadow-lg md:h-auto md:overflow-y-hidden lg:px-6 lg:py-8"
        onClick={(e) => e.stopPropagation()}
      >
        <HiX
          className="absolute right-4 top-4 cursor-pointer text-primary hover:text-red-500"
          size={20}
          onClick={onClose}
        />

        <h1 className="text-center text-3xl font-bold tracking-wide text-primary">
          Assign Staff
        </h1>

        {/* Input Fields */}
        <form className="my-4 grid grid-cols-1 gap-4 md:grid-cols-2">
          {/* Assign Staff */}
          {loading ? (
            <div className="col-span-2">
              <input className="w-full animate-pulse rounded bg-skeletonLoaderColor" />
            </div>
          ) : (
            <div className="col-span-2 flex flex-col gap-2">
              <select
                name="staffAssigned"
                id="staffAssigned"
                value={assignedStaff}
                onChange={(e) => setAssignedStaff(e.target.value)}
                className="rounded border bg-transparent px-4 py-2 outline-none focus:ring-1 focus:ring-primary"
              >
                <option value="" selected>
                  Select Staff
                </option>
                {staffs?.map((staff, index) => (
                  <option key={index} value={staff._id}>
                    {staff.name}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Buttons */}
        </form>
        <div className="flex justify-center">
          <button
            type="submit"
            onClick={handleSubmit}
            className="mt-4 flex w-fit items-center justify-center rounded bg-primary px-2 py-2 text-center font-semibold tracking-wide text-white shadow-md hover:bg-hoverPrimary"
          >
            {submitLoader ? <div className="loaderButton"></div> : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AssignStaff;
